import $ from 'jquery';
import React,{useEffect} from 'react';
import {appGetUrlPath,getWaUrlPath,CallMapMethod_CBack} from '../function_lib/common_lib';
import axios from 'axios';

export function Comp_Sync_Study_Media(props){
    let appUrl=appGetUrlPath();


    
const fetchFileBase64TwoAx = async (filename,memberEnc,studyKey) => {
    try {
      // send JSON { file: "example.pdf" }
      //alert(appUrl+"getAuthMediaFile")
      const response = await axios.post(appUrl+"memb_c/getAuthMediaFile", { filenm: filename,member:memberEnc,studykey:studyKey });
      //alert(JSON.stringify(response));
      if (response.data.error) {
        return "0";
        //throw new Error(response.data.error);
      }
  
      return response.data;
    } catch (error) {
      return "0";
      //console.error("Download error:", error);
      //throw error;
    }
  };


  //below function have no use
  const fetchFileBase64 = async (filename,memberEnc,studyKey) => {
        alert(`${appUrl}getAuthMediaFile?filenm=${filename}&member=${memberEnc}&studykey=${btoa(studyKey)}`);

        const response = await fetch(`${appUrl}getAuthMediaFile?filenm=${filename}&member=${memberEnc}&studykey=${btoa(studyKey)}`);
        alert(JSON.stringify(response));
        const data = await response.json();
        return data; // assuming API returns { base64: "...." }
      };

    const initiateMediaDownload= async () =>{
        //alert("I m initiating the llo1111 888");
        //alert(JSON.stringify(props.studyMedia));
        for (let i = 0; i < props.studyMedia.length; i++) {
            try{
              let map=[];
                if(props.studyMedia[i]["file_path"]!==""){
                    const responseMedia = await fetchFileBase64TwoAx(props.studyMedia[i]["file_path"],props.userObject[0]["id"],props.studyMedia[i]["id"]);
                    if(responseMedia!=="0"){
                      //alert("final JSON "+JSON.stringify(responseMedia));
                      
                      map=[];
                      map.push({name:"curl_type",value:"submitSyncedStudyMedia"});
                      map.push({name:"res_func",value:"callBackrrr"});
                      map.push({name:"local_token",value:props.userObject[0].id});
                      map.push({name:"user_type",value:props.userObject[0].type});
                      map.push({name:"stu_material_id",value:btoa(props.studyMedia[i]["id"])});
                      map.push({name:"file_name",value:btoa(props.studyMedia[i]["file_path"])});
                      map.push({name:"file_type",value:responseMedia.mimeType});
                      map.push({name:"file_data",value:JSON.stringify(responseMedia)});
                      map.push({name:"sync_type",value:"officer_master"});
                      map["res_func"]="callBackrrr";
                      map["curl_type"]="submitSyncedStudyMedia";
                      CallMapMethod_CBack(this,map,function(data,msg){
                        //alert("after insert==="+data+" == "+msg);
                      })

                    }
                    
                    //break;
                }
            }catch(err){
                alert(err);
            }
           
        }
        alert(props.studyMedia.length+" Synced Successfully ")

    }
    useEffect(()=>{
        if(props.studyMedia.length>0){
          //alert(JSON.stringify(props.studyMedia));
        }
    },[props.studyMedia])
    return(<div className="modal fade bd-example-modal-xl"  id="divSyncStudyMedia" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xxl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">{"Download Task Media Files"}</h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmSyncStudyMedia" name="frmSyncStudyMedia" enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()">
       
        <input type="hidden" id="global_token" name="global_token" value={props.userObject[0]["id"]}/>
        <input type="hidden" id="local_token" name="local_token" value={props.userObject[0]["id"]}/>
     
             

       
        <div className="modal-body">
           
        <div className="row">
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                               <div className="card-body">
                                <h5>{}</h5>
                                The media download will take approximately 15 to 20 minutes. Please ensure that you have a stable internet connection during this time.
                             
                               
                               
                                
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                          
                      </div>
                  </div>
                  </div>
                 
              <div class="row">
                <div class="col-12">
                <div onClick={()=>initiateMediaDownload()}  style={{marginRight:"10px"}} id="btnCatSearch" name="btnCatSearch" className="  bottom-fixed btn btn-sm btn-danger">Click to Start Downloads</div>
                </div>
              </div>
        </div>
        <div className="modal-footer mb-5">
        
             {/* <div onClick={()=>this.resetFilters()} className="btn btn-sm btn-primary">STO Approve</div> */}
        <div id="getReponse" style={{color:"red"}}></div>
         
        </div>
        </form>
      </div>
      </div>
      </div>);
}
export default Comp_Sync_Study_Media;